import React,{useEffect} from 'react'
import Banner from '../commonComponets/Banner'
import AboutUsScreen from '../componets/aboutus/AboutUsScreen'

const AboutUs:React.FC = () => {

    useEffect(()=>{
        // //document.title = "About Us"
    },[])

    return (
        <>
            <Banner title="About Us" />
            <AboutUsScreen/>
        </>
    )
}

export default AboutUs
